<template>
   <div class="video-js-player-wrapper" v-if="urlSources.length && urlPlaying">
      <video
         :id="playerWrapper"
         :poster="imgCover"
         class="video-js video-center"
         preload="auto"
         ref="videoPlayer"
         playsinline
         webkit-playsinline
         controls
      >
         <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
         </p>
      </video>
      <div class="video-js-player-wrapper__state-video-actions">
         <b-button
            class="ml-3 unmute-stream-init-btn"
            variant="light"
            @click="unMuteVideo()"
            v-b-tooltip.hover
            title="Un-mute Stream"
            v-if="isMuted && isShowMuteBtn"
         >
            <b-img src="@/assets/media/icons/no-sound.svg" alt="mute-unmute"></b-img>
            {{ viewerUsingMobileOS === mobileOS.UN_KNOWN ? "Click" : "Tap" }} to unmute
         </b-button>
      </div>
      <slot name="additional-layout"></slot>
      <!-- <div class="hover-overlay" v-show="isShowResumeVideo" @click="resumeVideo()">
         <div class="hover-play-img">
            <b-img src="@/assets/media/icons/play-icon.png" alt="play" class="play-icon"></b-img>
         </div>
      </div> -->
   </div>
</template>

<script>
import VideoJsPlayer from "../assets/js/components/video-js-player";

export default VideoJsPlayer;
</script>

<style lang="scss">
@import "../assets/scss/components/video-js-player";
</style>
